import { configureStore } from '@reduxjs/toolkit';
import authReducer from '@/shared/store/authSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    // courses removed — migrated to TanStack Query
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
